import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import Modal from "@/common/elements/Modal";
import { StyledFlex, StyledGridCol, StyledGridRow, StyledDarkSectionTitle } from "@/common/styles";
import { useEffect, useState } from "react";
import InmateWatchDetail from "./InmateWatchDetail";
import { Form, notification } from "antd";
import { useForm, useWatch } from "antd/es/form/Form";
import {
  getOptionsFromRefList,
  getRefListNameByID,
  isNonEmptyVariable,
} from "@/util/common_function";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import TimePicker from "@/common/elements/TimePicker";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import useDialog from "@/hooks/useDialog";
import { set } from "lodash";

export default function InmateWatch() {
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [payload, setPayload] = useState(null);
  const [total, setTotal] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const [modalType, setModalType] = useState(null);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const history = useWatch("includeHistory", form);
  const [commentlog, setCommentLog] = useState(null);
  const [bookings, setBooking] = useState(null);
  const refList = useSelector((state) => state?.refListReducer?.refLists);
  const [watchGroup, setWatchGroup] = useState([]);
  const [searchType, setSearchType] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState({
    headers: [
      { key: "commentLogId", text: "ID" },
      { key: "currentLocation", text: "Current Location" },
      { key: "categoryName", text: "Category" },
      { key: "inmate", text: "Inmate" },
      { key: "interval", text: "Interval" },
      { key: "lastWatchDate", text: "Last Watch Date" },
      { key: "time", text: "Time" },
      { key: "update", text: "Update" },
      { key: "comments", text: "Comments" },
      { key: "enteredBy", text: "Entered By" },
    ],
    rows: [],
  });
  const [hasActiveSearch, setHasActiveSearch] = useState(false);
  const [autoRefreshEnabled, setAutoRefreshEnabled] = useState(true);
  useEffect(() => {
    form.setFieldValue("searchType", "Starts With");
    return () => {
      form.resetFields();
    };
  }, []);
  useEffect(() => {
    if (!hasActiveSearch) {
      return;
    }
    getInmateWatch();
  }, [hasActiveSearch, payload, pagination]);

  useEffect(() => {
    if (!hasActiveSearch || !autoRefreshEnabled) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      getInmateWatch();
    }, 30000);

    return () => clearInterval(intervalId);
  }, [hasActiveSearch, autoRefreshEnabled, payload, pagination]);
  useEffect(() => {
    let watchGroupList = getOptionsFromRefList("Watch_Group");
    let searchTypeList = getOptionsFromRefList("Search_Type");
    if (isNonEmptyVariable(watchGroupList) && watchGroupList?.length > 0)
      setWatchGroup([...watchGroupList]);
    if (isNonEmptyVariable(searchTypeList) && searchTypeList?.length > 0)
      setSearchType([...searchTypeList]);
  }, [refList]);
  async function getInmateWatch() {
    try {
      setIsLoading(true);
      const url =
        API_ENDPOINTS.inmateWatch.search +
        `?page=${pagination.pageIndex}&size=${pagination.pageSize}`;
      const requestPayload = Array.isArray(payload) ? payload : [];
      const { data } = await api.post(url, requestPayload);
      const Rows = Array.isArray(data?.rows) ? data.rows : [];
      const Total = data?.total;

      const formattedRows = Rows.map((row) => {
        const enteredById = row?.enteredBy;

        const enteredByName = enteredById
          ? getRefListNameByID("", enteredById, true)
          : row?.enteredByName;

        return {
          ...row,
          categoryName:
            getRefListNameByID("Comment_Log_Category", row?.category) || "-",
          currentLocation: isNonEmptyVariable(row?.currentLocation)
            ? row?.currentLocation
            : "-",
          inmate: isNonEmptyVariable(row?.inmate) ? row?.inmate : "-",
          enteredBy: enteredByName ?? row?.enteredBy ?? "-",
        };
      });
      setIsLoading(false);
      setTableData((prev) => ({ ...prev, rows: formattedRows }));
      setTotal(isNonEmptyVariable(Total) ? Total : 0);

      if (Rows.length === 0) {
        setCommentLog(null);
        setBooking(null);
      }
    } catch (error) {
      console.log(error);
      setTableData((prev) => ({ ...prev, rows: [] }));
      setTotal(0);
      setCommentLog(null);
      setBooking(null);
      setIsLoading(false);
    }
  }
  async function onSubmit() {
    try {
      const values = await form.validateFields();

      const filteredEntries = Object.entries(values)?.filter(([key, value]) => {
        if (dayjs?.isDayjs(value)) {
          return value;
        }
        return isNonEmptyVariable(value);
      });

      const Payload =
        filteredEntries?.map(([key, value]) => {
          const formattedValue = dayjs?.isDayjs(value)
            ? key.includes("Time")
              ? value?.format("HH:mm")
              : value.format("MM/DD/YYYY")
            : value;

          return { filterKey: key, value: formattedValue };
        }) || [];

      // Always reset to the first page before issuing a new search
      setPagination((prev) => ({ ...prev, pageIndex: 0 }));
      setPayload(Payload);
      setHasActiveSearch(true);
    } catch (error) {
      // antd already surfaces field validation errors, so we can silently ignore here
    }
  }
  async function handleRowClick(values) {
    try {
      if (isNonEmptyVariable(values)) {
        let { commentLogId } = values;
        if (isNonEmptyVariable(commentLogId)) {
          let url = API_ENDPOINTS.facilityLog.getByID + commentLogId;
          let { data } = await api.get(url);
          if (isNonEmptyVariable(data)) {
            let { commentLog, booking } = data;
            if (isNonEmptyVariable(commentLog)) {
              setCommentLog(commentLog);
            } else {
              setCommentLog(null);
            }
            if (isNonEmptyVariable(booking)) {
              setBooking(booking);
            } else {
              setBooking(null);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  const openModal = (type) => {
    if (!commentlog) {
      return;
    }
    setModalType(type);
    setShowDetailModal(true);
  };

  const onHandleDetail = () => {
    openModal("view");
  };

  const onHandleUpdate = () => {
    openModal("update");
  };
  const { showDialog } = useDialog();

  const normalizeDateValue = (value) => {
    if (!isNonEmptyVariable(value)) {
      return "";
    }
    if (dayjs.isDayjs(value)) {
      return value.format("MM/DD/YYYY");
    }
    const parsed = dayjs(
      value,
      ["MM/DD/YYYY", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"],
      true
    );
    return parsed.isValid() ? parsed.format("MM/DD/YYYY") : String(value);
  };

  const normalizeTimeValue = (value) => {
    if (!isNonEmptyVariable(value)) {
      return "";
    }
    if (dayjs.isDayjs(value)) {
      return value.format("HH:mm");
    }
    const parsed = dayjs(value, ["HH:mm", "HH:mm:ss"], true);
    return parsed.isValid() ? parsed.format("HH:mm") : String(value);
  };

  const normalizeTextValue = (value) =>
    isNonEmptyVariable(value) ? String(value) : "";

  async function handleModelSubmit() {
    try {
      if (!commentlog) {
        notification.warning({
          message: "No Selection",
          description: "Select a watch entry before attempting to update it.",
        });
        return;
      }
      const data = await form2.validateFields();

      const updatedSnapshot = {
        scope: normalizeTextValue(data?.commentLogScopeID),
        shift: normalizeTextValue(data?.shiftID),
        interval: normalizeTextValue(data?.inmateWatch?.[0]?.interval),
        expirationDate: normalizeDateValue(data?.expirationDate),
        expirationTime: normalizeTimeValue(data?.expirationTime),
        comments: normalizeTextValue(data?.comments),
      };

      const originalSnapshot = {
        scope: normalizeTextValue(commentlog?.commentLogScopeID),
        shift: normalizeTextValue(commentlog?.shiftID),
        interval: normalizeTextValue(commentlog?.inmateWatch?.[0]?.interval),
        expirationDate: normalizeDateValue(commentlog?.expirationDate),
        expirationTime: normalizeTimeValue(commentlog?.expirationTime),
        comments: normalizeTextValue(commentlog?.comments),
      };

      const hasOtherChanges =
        updatedSnapshot.scope !== originalSnapshot.scope ||
        updatedSnapshot.shift !== originalSnapshot.shift ||
        updatedSnapshot.interval !== originalSnapshot.interval ||
        updatedSnapshot.expirationDate !== originalSnapshot.expirationDate ||
        updatedSnapshot.expirationTime !== originalSnapshot.expirationTime;

      const hasCommentChanged =
        updatedSnapshot.comments !== originalSnapshot.comments;

      if (modalType === "update" && hasOtherChanges && !hasCommentChanged) {
        showDialog("warning", {
          title: "Warning",
          content:
            "Comments must be updated before saving changes to the watch details.",
          confirmButtonText: "OK",
        });
        return;
      }

      let values = {};
      Object?.entries(data)?.forEach(([key, value]) => {
        if (isNonEmptyVariable(value)) {
          const formattedValue = dayjs.isDayjs(value)
            ? value.format("MM/DD/YYYYTHH:mm")
            : value;

          values[key] = formattedValue;
        }
      });
      if (isNonEmptyVariable(values["expirationDate"])) {
        let dateTime = values["expirationDate"].split("T");
        if (isNonEmptyVariable(dateTime)) {
          let expirationDate = dateTime[0];
          values.expirationDate = expirationDate;
        }
      }
      if (isNonEmptyVariable(values["expirationTime"])) {
        let dateTime = values["expirationTime"].split("T");
        if (isNonEmptyVariable(dateTime)) {
          let expirationTime = dateTime[1];
          values.expirationTime = expirationTime;
        }
      }
      // Merge the current comment log with the updated form values before persisting
      commentlog.commentLogID = null;
      let payloadValue = { ...commentlog, ...values };
      if (
        isNonEmptyVariable(commentlog?.inmateWatch) &&
        isNonEmptyVariable(values?.inmateWatch)
      ) {
        let inmateWatch = [
          { ...commentlog?.inmateWatch[0], ...values?.inmateWatch[0] },
        ];
        payloadValue.inmateWatch = inmateWatch;
      }
      if (isNonEmptyVariable(payloadValue)) {
        let url = API_ENDPOINTS.facilityLog.save;
        let { data } = await api.post(url, payloadValue);
        if (data?.statusCode == 200) {
          notification.success({
            message: "Success",
            description: "Data saved successfully",
          });
          await getInmateWatch();
          setCommentLog(null);
          setBooking(null);
          handleModelClose();
        } else {
          notification.error({
            message: "Error",
            description: "Error Saving Data",
          });
        }
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Error",
        description: "Error Saving Data",
      });
    }
  }
  function handleModelClose() {
    setShowDetailModal(false);
    setModalType(null);
    form2.resetFields();
  }
  const handleClear = () => {
    // Reset all filters and reload the grid in its unfiltered state
    form.resetFields();
    form.setFieldsValue({ searchType: "Starts With" });
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    setPayload([]);
    setCommentLog(null);
    setBooking(null);
    setTableData((prev) => ({ ...prev, rows: [] }));
    setTotal(0);
    setHasActiveSearch(false);
  };
  return (
    <>
      <StyledGridRow justify="space-between">
        <StyledGridCol span={24}>
          <StyledDarkSectionTitle bgColor="rgb(4 28 45)">
            <span>Inmate Watch</span>
          </StyledDarkSectionTitle>
        </StyledGridCol>
      </StyledGridRow>
      <Form form={form}>
        {history && (
          <>
            <StyledGridRow gutter={16}>
              <StyledGridCol span={6}>
                <StyledGridCol>
                  <FormItem label="Entered By" name="enteredBy">
                    <Select
                      options={getOptionsFromRefList("", true, false, true)}
                      placeholder="Select Staff"
                    />
                  </FormItem>
                </StyledGridCol>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <FormItem name="scope" label="Scope">
                  <Select
                    options={getOptionsFromRefList(
                      "Comment_Log_Scope",
                      false,
                      false,
                      true
                    )}
                    placeholder="Select Scope"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <FormItem name="block" label="Block">
                  <Select
                    options={getOptionsFromRefList("Block")}
                    // onChange={(value) =>
                    //   handlecellBedListOnChange(value, "cellList")
                    // }
                    placeholder="Select Block"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol span={6}>
                <FormItem label="Category" name="category">
                  <Select
                    options={getOptionsFromRefList(
                      "Comment_Log_Category",
                      false,
                      false,
                      true
                    )}
                    placeholder="Select Category"
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem label="Last Name" name="lName">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="First Name" name="fName">
                  <TextField />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol>
                <FormItem label="Middle Name" name="mName">
                  <TextField />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={3}>
                <FormItem label="Start Date" name="commentStartDate">
                  <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol lg={3}>
                <FormItem label="Start Time" name="commentStartTime">
                  <TimePicker showTime={false} />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol lg={3}>
                <FormItem label="End Date" name="commentEndDate">
                  <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
                </FormItem>
              </StyledGridCol>

              <StyledGridCol lg={3}>
                <FormItem label="End Time" name="commentEndTime">
                  <TimePicker showTime={false} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
            {/* <StyledGridRow gutter={16}>
                        <StyledGridCol lg={6}>
                            <FormItem label="Start Date" name="startDate">
                                <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
                            </FormItem>
                        </StyledGridCol>

                        <StyledGridCol lg={6}>
                            <FormItem label="Start Time" name="startTime">
                                <TimePicker showTime={false} />
                            </FormItem>
                        </StyledGridCol>
                        <StyledGridCol lg={6}>
                            <FormItem label="End Date" name="endDate">
                                <CommonDatePicker showTime={false} format="MM/DD/YYYY" />
                            </FormItem>
                        </StyledGridCol>

                        <StyledGridCol lg={6}>
                            <FormItem label="End Time" name="endTime">
                                <TimePicker showTime={false} />
                            </FormItem>
                        </StyledGridCol>
                    </StyledGridRow> */}
          </>
        )}
        <StyledGridRow gutter={16} justify="space-between">
          <StyledGridCol>
            <StyledGridRow gutter={16}>
              <StyledGridCol>
                <FormItem label="Watch_Group" name="watchGroup">
                  <Select
                    options={watchGroup}
                    placeholder="Select Watch_Group"
                    loading={true}
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol marginTop="30px">
                <FormItem
                  label="Include History?"
                  name="includeHistory"
                  layout="horizontal"
                  style={{ minWidth: "150px" }}
                  className="dark-form-item"
                  labelPostion="label-right"
                  valuePropName="checked"
                >
                  <Checkbox />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol>
                <FormItem
                  label="Search Type"
                  className="dark-form-item"
                  name="searchType"
                >
                  <Select options={searchType} loading={true} />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </StyledGridCol>

          <StyledGridCol>
            <StyledFlex gap="10px" align="center" marginTop="30px">
              <StyledFlex gap="10px">
                <Button onClick={handleClear}>Clear</Button>
                <Button onClick={onSubmit}>Search</Button>
              </StyledFlex>

              <FormItem
                label="Auto Refresh"
                layout="horizontal"
                style={{ minWidth: "150px" }}
                className="dark-form-item"
                labelPostion="label-right"
              >
                <Checkbox
                  checked={autoRefreshEnabled}
                  onChange={(event) =>
                    setAutoRefreshEnabled(event.target.checked)
                  }
                />
              </FormItem>
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
      <hr style={{ marginTop: "0px" }} />
      <StyledFlex align="center" justify="space-between" marginBottom="10px">
        <h5></h5>
        <StyledFlex gap="10px">
          <Button onClick={onHandleDetail} disabled={!commentlog}>
            Details
          </Button>
          <Button onClick={onHandleUpdate} disabled={!commentlog}>
            Update
          </Button>
        </StyledFlex>
      </StyledFlex>

      <DataTable
        headers={tableData.headers}
        data={tableData.rows}
        pagination={pagination}
        setPagination={setPagination}
        totalRecords={total}
        rowUniqueId="commentLogId"
        allowTableSorting={true}
        onRowClick={handleRowClick}
        isAPiCallLoading={isLoading}
      />

      {showDetailModal && (
        <Modal
          header="Inmate Watch"
          width="60%"
          show={showDetailModal}
          onHide={handleModelClose}
          handleCancel={handleModelClose}
          handleSubmit={handleModelSubmit}
          hideSubmitButton={modalType == "view"}
        >
          <InmateWatchDetail
            bookings={bookings}
            commentlog={commentlog}
            modalType={modalType}
            form={form2}
          />
        </Modal>
      )}
    </>
  );
}
